import { css, SerializedStyles } from '@emotion/core'

import { primarySelectedBorder, subtleSelectedBorder } from '../constants/colorTokens'
import { TagColor, TagType } from '../types'

export const getSelectedStyle = (type: TagType, color: TagColor): SerializedStyles => {
  if (type === 'primary') {
    return css`
      border-color: ${primarySelectedBorder};

      &:hover {
        border-color: ${primarySelectedBorder};
      }
    `
  }

  return css`
    border-color: ${subtleSelectedBorder[color]};

    &:hover {
      border-color: ${subtleSelectedBorder[color]};
    }
  `
}
